import React, { Component, createElement } from 'react'
import './css.css';
import utils from './../../library'
import Ticket1_0feed from '../Ticket1_0/feed'
import Icons from '../Icons/Icons'
import Web3 from 'web3'
import { splitUnit } from 'mathjs';

class PriceFeed extends Component {
    constructor(){
        super()
        this.state={
            defaultFrame:10000,
            feed:[],
            control:false
        }
    }
   componentDidMount(){
       let who="all"
       if(utils.getUrlVars()["feed"])who=utils.getUrlVars()["feed"]
       this.loadFeed("default",who,false)
   }

   async scan(){
       document.getElementById("PriceFeed_feed").setAttribute("state",document.getElementById("PriceFeed_feed").getAttribute("state")+1)
       document.getElementById("PriceFeed_feed").innerHTML=""
       
       let block=document.getElementById("PriceFeed_blockinput").value
       let addr=document.getElementById("PriceFeed_addressinput").value
     
       this.loadFeed(block,addr,true)
   }

   async getBlock(){
      let _block=await utils.getBlock()
      
        try{document.getElementById("PriceFeed_blockinput").value=parseInt(_block)-10000}catch(e){}
        return _block
   }

   async loadFeed(blck,who,listen){
    let state=document.getElementById("PriceFeed_feed").getAttribute("state")
    if(state=="0")document.getElementById("PriceFeed_feed").setAttribute("state",state++)
    const propertyValues = await utils.loadEvents(blck,who);

    if(listen){
        let scanning
        if(document.getElementById("PriceFeed_feed").getAttribute("scan")!="")scanning=document.getElementById("PriceFeed_feed").getAttribute("scan").split(",")
        if(document.getElementById("PriceFeed_feed").getAttribute("scan")=="")scanning=[]
        
        let arr=who.split(",")
        for(let x=0;x<arr.length;x++){
            if(!scanning.includes(arr[x])){
            scanning.push(arr[x])      
            document.getElementById("PriceFeed_feed").setAttribute("scan",scanning)
            alert(document.getElementById("PriceFeed_feed").getAttribute("scan"))
            utils.loadNewEvents(blck,arr[x],document.getElementById("PriceFeed_feed"))
            }
        }
    }
    let arr=Object.values(propertyValues)
    let arr2=[]
    if(arr!="x"){
        if(arr.length>0){
            document.getElementById("PriceFeed_notfound").innerHTML=""
            document.getElementById("PriceFeed_amountfeed").innerHTML=arr.length
            for(let i=arr.length-1;i>=0;i--){
                if(document.getElementById("PriceFeed_feed").getAttribute("state")==state){
                    let code=4
                    let f
                    try{code=await utils.ticketCode(arr[i].returnValues.owner)}catch(e){}

                    if(code==4)f=await Ticket1_0feed.display(arr[i].returnValues.coin,arr[i].returnValues.owner,false)

                    if(document.getElementById("PriceFeed_feed").childElementCount==0)document.getElementById("PriceFeed_notfound").innerHTML=""
                    document.getElementById("PriceFeed_feed").append(f);

                }else{
                    i=-1
                }
            }
        }
    if(arr.length==0){
    document.getElementById("PriceFeed_notfound").innerHTML="nothing 💔 found"
    document.getElementById("PriceFeed_amountfeed").innerHTML=0
    }
    
    }
    this.setState({feed:arr2})
   }

   toggleControl(){
       if(this.state.control){
           this.setState({control:false})
       }else{
        this.setState({control:true})

       }
   }

    render(){
        console.log(this.props.update) 



        return ( 
            <center>
            <div className="PriceFeed_panel">
            <div className="Feed_header left"><Icons icon="feed" d="100"/><div className="PriceFeed_panel_label">assets feed</div></div>
            <div className="icon_right right" onClick={() => this.toggleControl()}><Icons icon="lens" d="50 right"/><div id="PriceFeed_amountfeed" className="PriceFeed_amountfeed">0</div></div>
            <div className="clear"></div>
            {(this.state.control)?
            <div className="PriceFeed_controlpanel dark darkblue">
                <div className="PriceFeed_addressinput_label text white left">address:</div>
                <input type="text" id="PriceFeed_addressinput" className="PriceFeed_addressinput light lightblue text white right" defaultValue="all"></input>
                <div className="clear"></div>
                <div className="PriceFeed_blockinput_label text white left">from block:</div>
                <input type="text" id="PriceFeed_blockinput" className="PriceFeed_blockinput light lightblue text white left" defaultValue={parseInt(this.getBlock())-this.state.defaultFrame}></input>
                <div className="PriceFeed_search_button light lightblue text white right" onClick={() => this.scan()}>👂 LISTEN</div>
                <div className="clear"></div>
            </div>
            :<></>
            }
            <div id="PriceFeed_feed" scan="">
               
            </div>
            <div id="PriceFeed_notfound" className="text white"></div>
            {(this.state.control)?
            <div className="PriceFeed_info dark darkblue white text">
                Each time you scan you overlay a real time listener to the previous ones.<br></br>Reload the page to erase previous listeners.
            </div>
            :<></>
            }
            </div>
            </center>
        );
    }

}
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")
export default PriceFeed